import * as Yup from 'yup'

export const stripeConnectOnboardingSchema = Yup.object({
    country:Yup.string().required('INPUT.VALIDATION.COUNTRY'),
    additional_information:Yup.string()
})